import moment from 'moment';
import { isPickupUrgentForRunType, getRelevantUrgentText } from '../../utils/collectionTypes';

export const PickupStatus = (pickup, runTypeCode) => {
  let badge = 'badge badge-danger';
  let icon = 'fa fa-square-o';
  let text = '';
  let colour = '';
  const isUrgentForThisRun = isPickupUrgentForRunType(pickup, runTypeCode);
  const urgentText = getRelevantUrgentText(pickup, runTypeCode);


  if (pickup.pickupStatusCode == 'PEN') {
    if (isUrgentForThisRun) {
      colour = 'danger';
      badge = 'badge badge-danger';
      icon = 'fa fa-exclamation-triangle fa-2x text-danger';
      text = urgentText;
    } else {
      colour = 'warning';
      badge = 'badge badge-warning';
      icon = '';
      text = 'pending';
    }
  } else if (pickup.pickupStatusCode == 'COM') {
    colour = 'success';
    badge = 'badge badge-success';
    icon = 'fa fa-check-square fa-2x text-success';
    text = `${moment(pickup.datePickedUp).format('ddd, Do, LT')}`;
  }
  else if (pickup.pickupStatusCode == 'CREQ') {
    if (isUrgentForThisRun) {
      colour = 'danger';
      badge = 'badge badge-default';
      icon = 'fa fa-exclamation-triangle fa-2x text-muted';
      text = pickup.datePickedUp ? `${moment(pickup.datePickedUp).format('ddd, Do, LT')}` : urgentText;
    }else{
      colour = 'info';
      badge = 'badge badge-info';
      icon = 'fa fa-info-circle fa-2x text-info';
      text = `${moment(pickup.datePickedUp).format('ddd, Do, LT')}`;
    }
  }  else if (pickup.pickupStatusCode == 'CAN') {
    if (isUrgentForThisRun) {
      colour = 'danger';
      badge = 'badge badge-default';
      icon = 'fa fa-exclamation-triangle fa-2x text-muted';
      text = pickup.datePickedUp ? `${moment(pickup.datePickedUp).format('ddd, Do, LT')}` : urgentText;
    } else {
      colour = 'secondary';
      badge = 'badge badge-default';
      icon = 'fa fa-ban fa-2x text-muted';
      text = `${moment(pickup.datePickedUp).format('ddd, Do, LT')}`;
    }
  }

  if(pickup.addedByDriverUserId !== undefined || pickup.addedByDriverUserId !== null){
    text = `${text} - added by driver`;
  }

  return {
    text: text,
    icon: icon,
    badge: badge,
    colour: colour,
  };
};
